import { Link, useParams } from '@tanstack/react-router'
import { Thread } from '../components/answer/Thread.jsx'
import { ChatHeader } from '../components/ChatHeader.jsx'
import { LoadingState } from '../components/ui/LoadingState.jsx'
import { errorMessage } from '../lib/api.js'
import { formatDate } from '../lib/dates.js'
import { useSharedConversation } from '../lib/queries/conversations.js'
import { useSystemsMap } from '../lib/queries/systems.js'
import p from './pages.module.css'

/** Read-only view of a shared conversation (any signed-in DCKAP user). */
export function SharePage() {
  const { shareId } = useParams({ strict: false })
  const systemsMap = useSystemsMap()
  const shared = useSharedConversation(shareId)

  if (shared.isError) {
    return (
      <div className={p.chat}>
        <ChatHeader title="Shared conversation" />
        <div className={p.centerState}>
          <h2>This link doesn't work</h2>
          <p>{errorMessage(shared.error)}</p>
          <Link to="/new" className="btn btn-dark">
            Ask a new question
          </Link>
        </div>
      </div>
    )
  }

  const data = shared.data
  return (
    <div className={p.chat}>
      <ChatHeader
        title={data?.conversation.title ?? 'Shared conversation'}
        subtitle={
          data
            ? `Shared${data.share.sharedBy ? ` by ${data.share.sharedBy}` : ''} · ${formatDate(data.share.sharedAt)} · read-only`
            : 'Loading…'
        }
      />
      <div className={p.thread}>
        {shared.isPending ? (
          <LoadingState label="Loading shared conversation…" />
        ) : (
          <div className={p.column}>
            <Thread
              messages={data.messages}
              turns={data.turns}
              systemsMap={systemsMap}
              widgetStates={data.widgets}
              readOnly
            />
          </div>
        )}
      </div>
    </div>
  )
}
